module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-f751082b8fdf2a71dd5cf6f8451abc15.png";